<template>
  <div class="loginpage">
    <div class="bg_img">
      <img class="bg_img" src="../../assets/images/login_bg.png" alt="" />
    </div>
    <div>
      <div class="logon_logo">
        <div class="login-img-box">
          <img :src="$global.loginHeader" alt="" />
        </div>
      </div>
      <div class="login_min">
        <div>
          <el-button
            type="text"
            @click="showSetting"
            class="urlSetting"
            v-show="$global.urlSetting"
            ><i
              style="font-size: 24px; color: #436bff"
              class="iconfont urlSetting-icon icon-url-setting"
            ></i>
          </el-button>

          <div class="login_min_left">
            <img src="../../assets/images/login_min_left.png" alt="" />
          </div>
          <div class="login_min_line"></div>
          <div class="login_min_right">
            <el-form
              :model="formParams"
              ref="ruleForm"
              class="login_min_rightform"
            >
              <el-form-item
                class="animated fadeIn delay-2s login_animated"
                prop="account"
                v-if="formParams.loginType == 'pwd'"
                :rules="formRules.userName"
              >
                <div class="item_label">账号</div>
                <el-input
                  clearable
                  class="login_input"
                  v-model.trim="formParams['account']"
                ></el-input>
              </el-form-item>
              <el-form-item
                class="animated fadeIn delay-2s login_animated"
                prop="pwd"
                v-if="formParams.loginType == 'pwd'"
                :rules="formRules.userPassworm"
              >
                <div class="item_label">密码</div>
                <el-input
                  class="login_input"
                  show-password
                  v-model.trim="formParams['pwd']"
                  clearable
                >
                </el-input>
              </el-form-item>
              <el-form-item
                class="animated fadeIn delay-2s login_animated"
                prop="authCode"
                v-if="formParams.loginType == 'pwd'"
                :rules="formRules.requiredBlur"
              >
                <div class="authCode">
                  <div class="item_label">验证码</div>
                  <el-input
                    class="login_input"
                    @blur="authCodeBlur"
                    v-model.trim="formParams['authCode']"
                    clearable
                  >
                  </el-input>
                  <div class="authCode_img" @click="resetAuthCode">
                    <img :src="authCodeImg" alt="验证码" />
                  </div>
                </div>
              </el-form-item>
              <el-form-item
                prop="account"
                class="animated fadeIn login_animated"
                v-if="formParams.loginType == 'code'"
                :rules="formRules.phoneNmuber"
              >
                <div class="item_label">手机号</div>
                <el-input
                  class="login_input"
                  v-model.trim="formParams['account']"
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item
                prop="authCode"
                class="animated fadeIn login_animated"
                v-if="formParams.loginType == 'code'"
                :rules="formRules.requiredChange"
              >
                <div class="item_label">验证码</div>
                <div class="yzm_box">
                  <el-input
                    class="login_input"
                    v-model.trim="formParams['authCode']"
                  >
                    <el-button
                      slot="suffix"
                      class="send_btn suffix-send_btn"
                      :style="disabledCode ? 'color:#AEAEAE' : 'color:#436bff'"
                      @click.stop="sendCode"
                      :disabled="disabledCode"
                      type="text"
                      >{{ codeText }}</el-button
                    >
                  </el-input>
                </div>
              </el-form-item>
              <div class="flex_between_nowrap last_item">
                <el-checkbox
                  size="medium"
                  class="login_checked"
                  v-model.trim="formParams['isChecked']"
                  >{{
                    formParams.loginType == "pwd" ? "记住账号" : "记住手机号"
                  }}</el-checkbox
                >
                <el-button
                  type="text"
                  v-show="$global.mobileLogin"
                  @click="loginTypeFlag"
                  class="loginType_switch"
                  >{{
                    formParams.loginType == "pwd" ? "手机号登陆" : "密码登陆"
                  }}</el-button
                >
              </div>
              <el-form-item>
                <el-button class="submit_btn" @click="submit">登陆</el-button>
              </el-form-item>
            </el-form>
            <div class="copyright">{{ $global.copyright }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getRsaPwd } from "@/utils/rsaPassword";
export default {
  data() {
    return {
      authCodeImg: "",
      codeText: "发送验证码",
      disabledCode: false,
      formParams: {
        account: "",
        authCode: "",
        pwd: "",
        loginType: this.$cookies.get("loginType")
          ? this.$cookies.get("loginType")
          : "pwd",
        isChecked: true,
      },
    };
  },
  mounted() {
    window.addEventListener("keydown", this.handleKeyDown);
    this.resetInit();
  },

  beforeDestroy() {
    window.removeEventListener("keydown", this.handleKeyDown);
  },
  methods: {
    // 删除掉用户信息,菜单 token
    resetInit() {
      window.sessionStorage.clear();
      this.$store.commit("menulist_set", []);
    },
    handleKeyDown(e) {
      let keyCode = e.keyCode || e.which || e.charCode;
      if (keyCode == 13) {
        this.submit();
      }
    },
    resetAuthCode() {
      this.$requestAxios(
        {
          url: "/public/captchaImage",
          data: {
            captchaImgType: "math",
            captchaType: "login",
            deviceCode: window.localStorage.getItem("deviceCode"),
          },
        },
        (data) => {
          this.authCodeImg = `data:image/jpg;base64,${data.data.img}`;
        }
      );
    },
    accountLogin(data) {
      if (this.formParams.loginType != "pwd") {
        delete data.pwd;
      }
      this.$requestAxiosForm(
        {
          url: "/login/login",
          data,
        },
        (data) => {
          window.sessionStorage.setItem("userinfo", JSON.stringify(data.data));
          this.$store.commit("userInfo_ser", data.data);
          window.sessionStorage.setItem("ZCTOKEN", data.data.token);
          window.sessionStorage.setItem("userInfo", JSON.stringify(data.data));
          this.$requestAxios(
            {
              url: "/pc/menu/authorityInfo",
              data: {},
            },
            (data) => {
              if (data.data.menus.length) {
                this.$treeChildrenEmp(data.data.menus);
                this.$store.commit("menulist_set", data.data.menus);
                window.sessionStorage.setItem(
                  "menus",
                  JSON.stringify(data.data.menus)
                );
              }
              setTimeout(() => {
                this.$router.replace("/home");
              });
            },
            (err) => {}
          );
        },
        (err) => {
          this.resetAuthCode();
        }
      );
    },

    authCodeBlur() {
      this.$nextTick(() => {
        this.$refs.ruleForm.clearValidate();
      });
    },

    deviceCode() {
      let s = [];
      let hexDigits = "0123456789abcdef";
      for (let i = 0; i < 36; i++) {
        s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
      }
      s[14] = "4";
      s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1);
      s[8] = s[13] = s[18] = s[23] = "-";

      let uuid = s.join("");
      return uuid;
    },
    init() {
      if (this.$cookies.get("loginType")) {
        this.$set(this.formParams, "loginType", this.$cookies.get("loginType"));
        if (this.$cookies.get("loginType") == "pwd") {
          if (this.$cookies.get("account") && this.$cookies.get("pwd")) {
            this.$set(this.formParams, "account", this.$cookies.get("account"));
            this.$set(this.formParams, "pwd", this.$cookies.get("pwd"));
          }
        } else {
          if (this.$cookies.get("phone")) {
            this.$set(this.formParams, "account", this.$cookies.get("phone"));
          }
        }
      }
      if (!localStorage.getItem("deviceCode")) {
        localStorage.setItem("deviceCode", this.deviceCode());
      }
      if (!this.$global.baseURL && this.$global.urlSetting) {
        this.showSetting();
        return;
      }
      // 图片验证码
      this.resetAuthCode();
      if (this.$router.history.current.query.account) {
        this.$set(
          this.formParams,
          "account",
          this.$router.history.current.query.account
        );
        this.$set(this.formParams, "pwd", "888888");
      }
    },

    getSecond(wait) {
      this.disabledCode = true;
      let _wait = wait;
      let _this = this;
      if (wait == 0) {
        this.disabledCode = false;
        this.codeText = "发送验证码";
        wait = _wait;
        clearTimeout(timeid);
      } else {
        this.codeText = "验证码(" + wait + "s)";
        wait--;
        var timeid = setTimeout(function () {
          _this.getSecond(wait);
        }, 1000);
      }
    },
    sendCode() {
      this.$refs.ruleForm.validateField("account", (err) => {
        if (err) {
          return false;
        } else {
          this.$requestAxios(
            {
              url: "/public/sendSms", //新增，修改，
              data: {
                captchaType: "login",
                phoneNumber: this.formParams.account,
                deviceCode: localStorage.getItem("deviceCode"),
              },
            },
            (data) => {
              setTimeout(() => {
                this.getSecond(60);
              }, 200);
            }
          );
        }
      });
    },
    settingCllBack(systemUrl) {
      this.$global.baseURL = systemUrl;
      this.resetInit();
      this.init();
      // let inputValue=localStorage.getItem('asset-urlSetting')||''
      // this.$prompt("请输入IP", "服务器地址", {
      //   confirmButtonText: "确定",
      //   cancelButtonText: "取消",
      //   inputValue,
      //   confirmButtonClass:'confirm-button'
      // })
      //   .then(({ value }) => {
      //     localStorage.setItem('asset-urlSetting',value)
      //     if(!value){
      //       this.$message({
      //       type: "info",
      //       message: "未配置服务器地址！",
      //     });
      //     }else{

      //     }
      //   })
      //   .catch(() => {

      //   });
    },
    showSetting() {
      this.$createDialog(this, {
        dialogConfig: {
          title: "IP配置",
          width: "360px",
          customClass: "el-dialog-center",
        },
        namespace: "login-setting",
        whetherDestruction: true,
        assemblyConfig: {
          callBack: this.settingCllBack,
        },
      });
    },
    loginTypeFlag() {
      this.$refs.ruleForm.resetFields();
      this.formParams.loginType =
        this.formParams.loginType == "pwd" ? "code" : "pwd";
      this.$set(this.formParams, "authCode", "");
      this.$nextTick(() => {
        this.$refs.ruleForm.clearValidate();
      });
      if (this.formParams.loginType == "pwd") {
        this.$set(
          this.formParams,
          "account",
          this.$cookies.get("account") ? this.$cookies.get("account") : ""
        );
        this.$set(
          this.formParams,
          "pwd",
          this.$cookies.get("pwd") ? this.$cookies.get("pwd") : ""
        );
      } else {
        this.$set(
          this.formParams,
          "account",
          this.$cookies.get("phone") ? this.$cookies.get("phone") : ""
        );
      }
      this.resetAuthCode();
    },
    submit() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          // 记录上次登陆的类型  操作cookies
          this.$cookies.set("loginType", this.formParams.loginType, -1);
          if (this.formParams.isChecked) {
            if (this.formParams.loginType == "pwd") {
              this.$cookies.set("account", this.formParams.account, -1);
              this.$cookies.set("pwd", this.formParams.pwd, -1);
            } else {
              this.$cookies.set("phone", this.formParams.account, -1);
            }
          } else {
            if (this.formParams.loginType == "pwd") {
              if (this.$cookies.get("account") && this.$cookies.get("pwd")) {
                this.$cookies.remove("account");
                this.$cookies.remove("pwd");
              }
            } else {
              if (this.$cookies.get("phone")) {
                this.$cookies.remove("phone");
              }
            }
          }
          // 获取rsa key
          this.$requestAxios(
            {
              url: "/public/public_key",
              data: {
                deviceCode: localStorage.getItem("deviceCode"),
              },
            },
            (data) => {
              let newform = Object.assign(
                {
                  device: "PC",
                  deviceCode: localStorage.getItem("deviceCode"),
                },
                this.formParams
              );
              delete newform.isChecked;
              newform.pwd = getRsaPwd(
                newform.pwd,
                data.data.modulus,
                data.data.exponent
              );
              this.accountLogin(newform);
            },
            (err) => {}
          );
        }
      });
    },
  },
};
</script>
<style scoped>
.loginpage {
  width: 100%;
  height: 100%;
  position: relative;
  background: radial-gradient(1600px 600px at 960px 540px, #436bff, #14329f);
  overflow: hidden;
}
.copyright {
  text-align: center;
  color: #ffffff;
  font-size: 12px;
  opacity: 0.4;
  margin-top: 15px;
}
.logon_logo {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: center;
  padding-top: 20px;
  padding-bottom: 50px;
}
.login-img-box {
  width: 168px;
  height: 156px;
}
.login-img-box > img {
  width: 100%;
  object-fit: fill;
  height: 100%;
}
.login_min {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: center;
}
.login_min > div {
  flex-shrink: 0;
  padding-left: 60px;
  box-sizing: border-box;
  overflow: hidden;
  width: 1200px;
  height: 500px;
  background-color: #172f85;
  box-shadow: 0px 3px 12px 0px rgba(0, 0, 0, 0.16);
  border-radius: 20px;
  position: relative;
}

.login_min_line {
  position: absolute;
  left: 50%;
  top: 64px;
  width: 1px;
  height: 360px;
  background-color: #436bff;
  box-shadow: 0px 3px 12px 0px rgba(0, 0, 0, 0.16);
  border-radius: 20px;
}
.login_min_left {
  box-sizing: border-box;
  position: absolute;
  left: 60px;
  top: 0;
}
.login_min_right {
  width: 360px;
  position: absolute;
  left: 740px;
  top: 60px;
}
.item_label {
  padding: 0;
  font-size: 16px;
  color: #ffffff;
  vertical-align: text-top;
  line-height: 16px;
  margin-bottom: 10px;
}
.authCode {
  position: relative;
}
.authCode .authCode_img {
  position: absolute;
  top: 26px;
  right: 0px;
  z-index: 1;
  width: 100px;
  height: 50px;
  border-radius: 0px 8px 8px 0px;

  overflow: hidden;
}
.authCode .authCode_img > img {
  width: 100%;
  height: 100%;
}
.last_item {
  margin-bottom: 16px;
  margin-top: -14px;
}
.submit_btn {
  padding: 0;
  background-color: #436bff;
  line-height: 40px;
  height: 40px;
  font-size: 16px;
  font-weight: bold;
  letter-spacing: 0px;
  color: #ffffff;
  width: 100%;
  letter-spacing: 8px;
  background-color: #436bff;
  box-shadow: 0px 8px 16px 0px rgba(67, 107, 255, 0.3);
  border-radius: 8px;
  border: 1px solid #436bff;
}
.bg_img {
  position: absolute;
  right: -250px;
  top: -107px;
  opacity: 0.6;
}
.login_min_rightform >>> .el-input__inner {
  height: 50px;
  line-height: 50px;
  font-size: 16px;
  color: #1e1e1e;
}
.loginType_switch {
  text-decoration: underline;
}
.yzm_box {
  position: relative;
}
.suffix-send_btn {
  height: 50px;
  margin-right: 10px;
}
.urlSetting {
  position: absolute;
  top: 24px;
  right: 32px;

  padding: 0;
}
</style>
